import {
  Box,
  Button,
  Grid,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import imgModelMobile from "assets/splashpage/campaginmobile.png";
import imgModel from "assets/splashpage/campaign_preview.png";
import { DiscoverViewContext } from "contexts/DiscoverView";
import { SubscriptionContext } from "contexts/Subscription";
import { useContext } from "react";
import { UpgradeDialogSource } from "schemas/dashboard";

import styles from "./styles";

const CampaignPreviewPage = () => {
  const { discoverTab } = useContext(DiscoverViewContext);
  const { setUpgradeDialogSource } = useContext(SubscriptionContext);
  const theme = useTheme();
  const isMobileScreen = useMediaQuery(
    theme.breakpoints.down(discoverTab ? "lg" : "md"),
  );

  const isMediumScreen =
    useMediaQuery(
      discoverTab !== null ? "(max-width:1400px)" : "(max-width:1200px)",
    ) && !isMobileScreen;

  const rightSide = (
    <Grid container item xs md sx={styles.rightSidebar(isMediumScreen)}>
      <Box>
        <Box sx={[styles.chip, { mb: 2 }]}>🔒 Locked feature</Box>

        <Box sx={{ mb: 4 }}>
          <Typography variant="h2" sx={styles.header}>
            <Box component="span" sx={styles.mainHeader}>
              Campaigns:
            </Box>{" "}
            <Box component="span" sx={[styles.mainHeader, { color: "black" }]}>
              Plan, measure, and scale your brand pitches.
            </Box>
          </Typography>

          <Typography sx={{ mt: 2, fontSize: { xs: 16, md: 20 } }}>
            Pitch hundreds of brands in one click and use campaign analytics to
            see what's working and improve your results.
          </Typography>
        </Box>

        <Button
          variant="contained"
          sx={{
            px: { xs: 2, md: 4 },
            py: 1.5,
            fontSize: { xs: 14, md: 16 },
            borderRadius: 10,
          }}
          disableElevation
          onClick={() =>
            setUpgradeDialogSource(UpgradeDialogSource.campaigns_preview)
          }
        >
          Upgrade to unlock campaigns
        </Button>
      </Box>
    </Grid>
  );

  return (
    <Box sx={isMobileScreen ? { p: 3 } : styles.main}>
      <Grid
        gap={2}
        container
        sx={{
          background: "white",
          borderRadius: 4,
          maxWidth: 1200,
        }}
      >
        {isMobileScreen && rightSide}

        {isMobileScreen ? (
          <Grid container justifyContent={"center"}>
            <Box
              src={imgModelMobile}
              component="img"
              sx={{ width: "100%", borderRadius: 8, maxWidth: 400 }}
            ></Box>
          </Grid>
        ) : (
          <Grid item xs={12} lg={6} sx={styles.leftSidebar}>
            <Grid
              container
              gap={1}
              item
              xs={12}
              justifyContent={isMobileScreen ? "center" : "flex-start"}
            >
              <Box sx={styles.chip}>Create Campaign *</Box>
              <Box sx={styles.chip}>Add Brands</Box>
              <Box sx={[styles.chip, { backgroundColor: "yellow.main" }]}>
                Track Replies
              </Box>
            </Grid>

            <Grid container justifyContent={"center"}>
              <Box
                src={isMediumScreen ? imgModelMobile : imgModel}
                component="img"
                sx={styles.image(isMediumScreen)}
              ></Box>
            </Grid>
          </Grid>
        )}

        {!isMobileScreen && rightSide}
      </Grid>
    </Box>
  );
};

export default CampaignPreviewPage;
